import { makeRequest, CommonRequestOptions } from '../../makeRequest';

export type GetUserCountsResult = {
   userCounts: {
      site: {
         privileged: number;
         nonPrivileged: number;
      };
      limits: {
         privileged: number;
         nonPrivileged: number;
      };
      allSites: null | {
         privileged: number;
         nonPrivileged: number;
      };
   };
};

export function getUserCounts({ ...common }: CommonRequestOptions): Promise<GetUserCountsResult> {
   return makeRequest('get', 'users/manage/stats', {
      ...common,
   });
}
